import { useToggleFoundTag, useIsFound } from '../hooks';
import { useCallback } from 'react';

interface FoundButtonProps {
  inboxId: string;
  currentTags?: string;
}

const FoundButton = ({ inboxId, currentTags = '' }: FoundButtonProps) => {
  const { toggleFoundTag, isLoading } = useToggleFoundTag();
  const isFound = useIsFound(currentTags);

  const handleToggle = useCallback(
    async (e: React.MouseEvent) => {
      e.stopPropagation();
      await toggleFoundTag(inboxId, currentTags);
    },
    [inboxId, currentTags, toggleFoundTag]
  );

  return (
    <button
      onClick={handleToggle}
      disabled={isLoading}
      className={`px-5 py-2 text-sm font-bold rounded border transition-all duration-200 ${
        isFound
          ? 'bg-blue-600 text-white border-blue-700 hover:bg-blue-700 shadow-sm'
          : 'bg-transparent text-gray-500 border-gray-300 hover:bg-blue-50 hover:text-blue-600 hover:border-blue-200'
      }`}
      title={isFound ? 'Quitar marca de encontrado' : 'Marcar como encontrado'}
    >
      {isLoading ? '...' : isFound ? 'LISTO' : 'PICKEADO?'}
    </button>
  );
};

export default FoundButton;
